import { ChevronRight, User } from 'lucide-react';
import { useState, useEffect } from 'react';
import basicIcon from '../../Assets/Images/rewamp/1.svg';

const safeValue = (val) =>
  val !== null && val !== undefined && val !== '' ? String(val) : '';

// Location data structure
export const locationData = {
  India: {
    'Odisha': ['Bhubaneswar','Cuttack','Puri','Berhampur','Sambalpur','Rourkela','Balasore','Bhadrak','Jajpur','Angul','Dhenkanal','Keonjhar','Koraput','Rayagada',
      'Nabarangpur','Kalahandi','Nuapada','Bargarh','Jharsuguda'],
   'Chhattisgarh': ['Raipur','Bilaspur','Durg','Bhilai','Korba','Raigarh','Jagdalpur',
      'Ambikapur','Dhamtari','Rajnandgaon','Mahasamund','Kanker'],
   'Maharashtra': [ 'Mumbai','Pune','Nagpur','Nashik','Aurangabad','Solapur','Kolhapur','Sangli','Satara','Ahmednagar','Jalgaon','Dhule','Akola','Amravati',
      'Wardha','Chandrapur','Yavatmal','Latur','Nanded','Parbhani' ],
    'Andhra Pradesh': ['Visakhapatnam','Vijayawada','Guntur','Nellore','Tirupati','Kurnool',
      'Rajahmundry','Eluru','Machilipatnam','Ongole','Kadapa','Anantapur','Chittoor','Srikakulam','Vizianagaram'],
    'Telangana': ['Hyderabad','Secunderabad','Warangal','Nizamabad','Karimnagar','Khammam','Ramagundam','Mahbubnagar','Siddipet' ],
    'Karnataka': [ 'Bangalore','Mysore','Mangalore','Hubli','Dharwad','Belgaum','Gulbarga','Bijapur','Shimoga','Davangere','Bellary','Udupi'],
    'Tamil Nadu': [  'Chennai','Coimbatore','Madurai','Trichy','Salem','Erode', 'Tirunelveli','Thoothukudi','Vellore','Tiruppur','Karur','Namakkal' ],
    'Kerala': [  'Thiruvananthapuram','Kochi','Kozhikode','Thrissur','Palakkad', 'Alappuzha','Kollam','Kottayam','Kannur','Malappuram'],
    'West Bengal': [ 'Kolkata','Howrah','Durgapur','Asansol','Siliguri','Bardhaman','Kharagpur','Haldia','Malda','Raiganj' ],
    'Gujarat': [  'Ahmedabad','Surat','Vadodara','Rajkot','Bhavnagar','Jamnagar',  'Junagadh','Anand','Nadiad','Morbi'],
    'Rajasthan': [ 'Jaipur','Jodhpur','Udaipur','Kota','Ajmer','Bikaner','Alwar', 'Bharatpur','Sikar','Pali' ],
    'Uttar Pradesh': ['Lucknow','Kanpur','Agra','Varanasi','Prayagraj','Meerut',  'Ghaziabad','Noida','Gorakhpur','Bareilly','Aligarh','Moradabad'],
    'Madhya Pradesh': [ 'Bhopal','Indore','Gwalior','Jabalpur','Ujjain','Ratlam', 'Rewa','Satna','Sagar','Chhindwara' ],
    'Bihar': ['Patna','Gaya','Bhagalpur','Muzaffarpur','Darbhanga',   'Purnia','Arrah','Begusarai','Katihar' ],
    'Jharkhand': [ 'Ranchi','Jamshedpur','Dhanbad','Bokaro','Hazaribagh',  'Giridih','Deoghar','Chaibasa'],
    'Assam': [ 'Guwahati','Dibrugarh','Silchar','Jorhat','Tezpur','Tinsukia','Nagaon','Sivasagar'  ],
    'Punjab': ['Chandigarh','Ludhiana','Amritsar','Jalandhar','Patiala','Bathinda','Mohali','Hoshiarpur' ],
    'Haryana': [ 'Gurgaon','Faridabad','Panipat','Ambala','Karnal','Rohtak','Hisar','Yamunanagar'],
    'Himachal Pradesh': ['Shimla','Solan','Dharamshala','Mandi','Kullu','Una','Hamirpur' ],
    'Uttarakhand': ['Dehradun','Haridwar','Roorkee','Haldwani','Rudrapur','Nainital','Kashipur'],
    'Jammu & Kashmir': ['Srinagar','Jammu','Anantnag','Baramulla','Pulwama','Kupwara' ],
    'Goa': ['Panaji','Margao','Vasco da Gama','Mapusa','Ponda' ],
    'Tripura': ['Agartala','Udaipur','Dharmanagar','Kailashahar'],
    'Meghalaya': ['Shillong','Tura','Nongpoh','Jowai'],
    'Manipur': [ 'Imphal','Thoubal','Bishnupur','Churachandpur'],
    'Mizoram': [ 'Aizawl','Lunglei','Champhai','Serchhip'],
    'Nagaland': ['Kohima','Dimapur','Mokokchung','Wokha'],
    'Arunachal Pradesh': ['Itanagar','Naharlagun','Pasighat','Tawang'],
    'Sikkim': ['Gangtok','Namchi','Gyalshing','Mangan' ]
  }
};


export default function BasicInformation({ onNext, patientInfo, patientData }) {
  const [initialized, setInitialized] = useState({
    patientInfo: false,
    patientData: false,
  });
  const [form, setForm] = useState({
    patientid: '',
    name: '',
    age: '',
    gender: '',
    mobile: '',
    height: '',
    weight: '',
    laborderdoc: '',
    createddate: '',
    country: 'India',
    state: 'Odisha',
    region: 'Bhubaneswar',
    language: 'English',
  });
  const [errors, setErrors] = useState({});
  const [availableStates, setAvailableStates] = useState(Object.keys(locationData['India']));
  const [availableCities, setAvailableCities] = useState(locationData['India']['Odisha']);

  const handleNumberChange = (name, min, max) => (e) => {
    const value = e.target.value;

    if (value === '') {
      setForm(prev => ({ ...prev, [name]: '' }));
      setErrors(prev => ({ ...prev, [name]: '' }));
      return;
    }

    const num = Number(value);
    if (Number.isNaN(num)) return;

    if (num < min || num > max) {
      setErrors(prev => ({
        ...prev,
        [name]: `${name} must be between ${min} and ${max}`,
      }));
      return;
    }

    setForm(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  useEffect(() => {
    if (patientInfo && !initialized.patientInfo) {
      setForm(prev => ({
        ...prev,
        patientid: safeValue(patientInfo.CODE),
        name: safeValue(patientInfo.NAME),
        age: safeValue(patientInfo.AGE),
        gender:
          patientInfo.GENDER === 'M'
            ? 'male'
            : patientInfo.GENDER === 'F'
              ? 'female'
              : '',
        mobile:
          patientInfo.MOBILE !== 'Undetermined'
            ? safeValue(patientInfo.MOBILE)
            : '',
        height: safeValue(patientInfo.HEIGHT),
        weight: safeValue(patientInfo.WEIGHT),
        laborderdoc: safeValue(patientInfo.LABORDERDOC),
        createddate: safeValue(patientInfo.CREATEDDATE),
      }));

      setInitialized(prev => ({ ...prev, patientInfo: true }));
    }
  }, [patientInfo, initialized.patientInfo]);

  // Restore previously entered form data (when user comes back from step 2)
  useEffect(() => {
    if (patientData && !initialized.patientData) {
      setForm(prev => ({
        ...prev,
        name: safeValue(patientData.name) || prev.name,
        age: safeValue(patientData.age) || prev.age,
        gender: patientData.gender || prev.gender,
        height: safeValue(patientData.height) ?? prev.height,
        weight: safeValue(patientData.weight) ?? prev.weight,
        mobile: safeValue(patientData.mobile) || prev.mobile,
        country: patientData.country || prev.country,
        state: patientData.state || prev.state,
        region: patientData.region || prev.region,
        language: patientData.language || prev.language,
      }));

      // Update available states and cities based on restored data
      if (patientData.country && locationData[patientData.country]) {
        setAvailableStates(Object.keys(locationData[patientData.country]));
        if (patientData.state && locationData[patientData.country][patientData.state]) {
          setAvailableCities(locationData[patientData.country][patientData.state]);
        }
      }

      setInitialized(prev => ({ ...prev, patientData: true }));
    }
  }, [patientData, initialized.patientData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const handleCountryChange = (e) => {
    const country = e.target.value;
    const states = Object.keys(locationData[country] || {});
    const firstState = states[0] || '';
    const cities = locationData[country]?.[firstState] || [];
    
    setForm({
      ...form,
      country,
      state: firstState,
      region: cities[0] || '',
    });
    setAvailableStates(states);
    setAvailableCities(cities);
    setErrors({ ...errors, country: '', state: '', region: '' });
  };

  const handleStateChange = (e) => {
    const state = e.target.value;
    const cities = locationData[form.country]?.[state] || [];
    
    setForm({
      ...form,
      state,
      region: cities[0] || '',
    });
    setAvailableCities(cities);
    setErrors({ ...errors, state: '', region: '' });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = 'Name is required';
    if (!form.age || form.age < 1 || form.age > 120) newErrors.age = 'Enter valid age (1-120)';
    if (!form.gender) newErrors.gender = 'Gender is required';
    if (!form.weight || form.weight <= 0) newErrors.weight = 'Weight is required';
    if (!form.height || form.height <= 0) newErrors.height = 'Height is required';
    if (!form.mobile.trim()) newErrors.mobile = 'Mobile number is required';
    if (form.mobile.length < 10) newErrors.mobile = 'Mobile number must be at least 10 digits';
    if (!form.country) newErrors.country = 'Country is required';
    if (!form.state) newErrors.state = 'State is required';
    if (!form.region) newErrors.region = 'Region is required';
    if (!form.language) newErrors.language = 'Language is required';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const dataToSend = {
        patientid: form.patientid,
        name: form.name,
        age: form.age,
        gender: form.gender,
        height: form.height,
        weight: form.weight,
        mobile: form.mobile,
        country: form.country,
        state: form.state,
        region: form.region,
        language: form.language,
        goal: '',
        food_preference: '',
        diseases: '',
        exercise_type: '',
        sleep_pattern: '',
        activity_level: '',
        allergies: '',
        water_intake: '',
        stress_level: '',
        menstrual_health: '',
        additional_info: '',
        pdf_report: '',
      };
      onNext(dataToSend);
    }
  };

  const inputClass =
    'w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent text-sm';
  const labelClass = 'block text-xs font-semibold text-textGray mb-1';
 const errorClass = 'text-red-500 text-xs mt-1';

  return (
    <div
      className="py-2 sm:py-3 px-2 sm:px-4"
      style={{
        backgroundColor: '#fff',
        backgroundImage: 'var(--section-bg-gradient)'
      }}
    >
      {/* Main Container - Full Width */}
      <div className="w-full max-w-full mx-auto">

        {/* Section Header */}
                     <div className="mb-5 sm:mb-6 flex items-center gap-3 sm:gap-4 px-2 sm:px-4">
  
  <div className="rounded-xl bg-[#EAF3FA] p-2.5 flex items-center justify-center shrink-0">
    <img 
      src={basicIcon} 
      alt="Basic Info" 
      className="h-12 w-12 sm:h-14 sm:w-14 object-contain"
    />
  </div>

  <div className="flex-1 min-w-0">
    <h2 
      className="text-lg sm:text-2xl font-bold break-words"
      style={{ color: "var(--color-brand-primary)" }}
    >
      Basic Information
    </h2>

    <p className="text-sm sm:text-base text-textGray mt-1 break-words">
      Tell us about yourself to create your personalised Diet recommendation
    </p>
  </div>

</div>

        {/* Form Container */}
        <div className="px-8">

          {/* Primary Form Fields */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">

            <div>
              <label className={labelClass}>Name <span className="text-[#FF6B6B]">*</span></label>
              <input
                name="name"
                value={form.name}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[a-zA-Z\s]*$/.test(value)) {
                    setForm({ ...form, name: value });
                    setErrors({ ...errors, name: '' });
                  } else {
                    setErrors({ ...errors, name: 'Name cannot contain numbers or special characters' });
                  }
                }}
                placeholder="Enter here"
                className={inputClass}
              />
              {errors.name && <p className={errorClass}>{errors.name}</p>}
            </div>

            <div>
              <label className={labelClass}>Age <span className="text-[#FF6B6B]">*</span></label>
              <input
                name="age"
                value={form.age}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === '') {
                    setForm({ ...form, age: value });
                    setErrors({ ...errors, age: '' });
                    return;
                  }
                  if (!/^[0-9]+$/.test(value)) {
                    setErrors({ ...errors, age: 'Only whole numbers are allowed' });
                    return;
                  }
                  if (Number(value) < 1 || Number(value) > 120) {
                    setErrors({ ...errors, age: 'Age must be between 1 and 120' });
                    return;
                  }
                  setForm({ ...form, age: value });
                  setErrors({ ...errors, age: '' });
                }}
                placeholder="Enter age"
                className={inputClass}
              />
              {errors.age && <p className={errorClass}>{errors.age}</p>}
            </div>

            <div>
              <label className={labelClass}>Gender <span className="text-[#FF6B6B]">*</span></label>
              <select
                name="gender"
                value={form.gender}
                onChange={handleChange}
                className={inputClass}
              >
                <option value="">Select here</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
              {errors.gender && <p className={errorClass}>{errors.gender}</p>}
            </div>

            <div>
              <label className={labelClass}>Weight (Kg) <span className="text-[#FF6B6B]">*</span></label>
              <input
                name="weight"
                type="text"
                value={form.weight}
                onChange={handleNumberChange('weight', 1, 500)}
                placeholder="Enter weight (Kg)"
                className={inputClass}
              />
              {errors.weight && <p className={errorClass}>{errors.weight}</p>}
            </div>

            <div>
              <label className={labelClass}>Height (Cm) <span className="text-[#FF6B6B]">*</span></label>
              <div className="flex gap-2">
                <input
                  name="height"
                  type="text"
                  value={form.height}
                  onChange={handleNumberChange('height', 1, 300)}
                  placeholder="Enter height (cm)"
                  className={inputClass}
                />
              </div>
              {errors.height && <p className={errorClass}>{errors.height}</p>}
            </div>

            <div>
              <label className={labelClass}>Mobile Number <span className="text-[#FF6B6B]">*</span></label>
              <input
                name="mobile"
                value={form.mobile}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === '') {
                    setForm({ ...form, mobile: value });
                    setErrors({ ...errors, mobile: '' });
                    return;
                  }
                  if (!/^[0-9]*$/.test(value)) {
                    setErrors({ ...errors, mobile: 'Only digits are allowed' });
                    return;
                  }
                  if (value.length > 10) {
                    setErrors({ ...errors, mobile: 'Mobile Number cannot exceed 10 digits' });
                    return;
                  }
                  setForm({ ...form, mobile: value });
                  setErrors({ ...errors, mobile: '' });
                }}
                maxLength="10"
                placeholder="Enter mobile number"
                className={inputClass}
              />
              <p className="text-xs text-textGray mt-1">pdf will be sent to this number</p>
              {errors.mobile && <p className={errorClass}>{errors.mobile}</p>}
            </div>

            {/* Region Section */}
            <div>
              <label className={labelClass}>Country <span className="text-[#FF6B6B]">*</span></label>
              <select
                name="country"
                value={form.country}
                onChange={handleCountryChange}
                className={inputClass}
              >
                <option value="India">India</option>
              </select>
              {errors.country && <p className={errorClass}>{errors.country}</p>}
            </div>

            <div>
              <label className={labelClass}>State <span className="text-[#FF6B6B]">*</span></label>
              <select
                name="state"
                value={form.state}
                onChange={handleStateChange}
                className={inputClass}
              >
                {availableStates.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
              {errors.state && <p className={errorClass}>{errors.state}</p>}
            </div>

            <div>
              <label className={labelClass}>Region <span className="text-[#FF6B6B]">*</span></label>
              <select
                name="region"
                value={form.region}
                onChange={handleChange}
                className={inputClass}
              >
                {availableCities.map((city) => (
                  <option key={city} value={city}>
                    {city}
                  </option>
                ))}
              </select>
              {errors.region && <p className={errorClass}>{errors.region}</p>}
            </div>

            {/* Language Section */}
            <div className="md:col-span-3">
              <label className={labelClass}>Which Language you prefer? <span className="text-[#FF6B6B]">*</span></label>
              <p className="text-xs text-textGray mb-3">Your pdf report will be generated in your preferred language</p>
              <div className="flex gap-6">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="language"
                    value="English"
                    checked={form.language === 'English'}
                    onChange={handleChange}
                    className="w-4 h-4 text-quantumPrimary"
                  />
                  <span className="text-sm">English</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="language"
                    value="Hindi"
                    checked={form.language === 'Hindi'}
                    onChange={handleChange}
                    className="w-4 h-4 text-quantumPrimary"
                  />
                  <span className="text-sm">Hindi</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="language"
                    value="Odia"
                    checked={form.language === 'Odia'}
                    onChange={handleChange}
                    className="w-4 h-4 text-quantumPrimary"
                  />
                  <span className="text-sm">Odia</span>
                </label>
              </div>
              {errors.language && <p className={errorClass}>{errors.language}</p>}
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-end mt-8">
           <button
  onClick={handleSubmit}
  className="flex items-center gap-2 rounded-full px-8 py-3 font-semibold text-white transition hover:opacity-90"
  style={{ backgroundColor: "var(--color-brand-primary)" }}   // ✅ exact bg color
>
  Next <ChevronRight className="h-4 w-4" />
</button>
          </div>
        </div>
      </div>
    </div>
  );
}